import {HTTP} from '@/CallAPI'
export default {
  getGroupOfChecklist (checklist = {}, status) {
    var stt = []
    status.forEach(item => {
      if (item.id) {
        stt.push(item.id)
      }
    })
    return HTTP.get('checklists/' + checklist.id + '/checklist-items', {params: {
      stt: stt.length ? stt : []
    }})
  },

  getUserOfChecklist (checklist = {}) {
    return HTTP.get('checklists/' + checklist.id + '/users')
  },

  getChecklistItemOfGroupChecklist (checklist = {}, group_checklist_item = {}, status) {
    var stt = []
    status.forEach(item => {
      if (item.id) {
        stt.push(item.id)
      }
    })
    return HTTP.get('checklists/' + checklist.id + '/group-checklist-items/' + group_checklist_item.id, {params: {
      stt: stt.length ? stt : []
    }})
  },

  changeStatusChecklistItemOfChecklist (checklist = {}, checklist_item = {}, status = {}) {
    return HTTP.put('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id, {stt_code: status.code})
  },

  quickReport (checklist = {}) {
    return HTTP.get('checklists/' + checklist.id + '/quick-reports')
  },

  history (checklist = {}, checklist_item = {}) {
    return HTTP.get('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id + '/histories')
  },

  getAllSummary (checklist) {
    return HTTP.get('checklists/' + checklist.id + '/meeting-minutes')
  },

  createSummary (checklist, data) {
    return HTTP.post('checklists/' + checklist.id + '/meeting-minutes', data)
  },

  searchChecklist (checklist, search) {
    return HTTP.get('checklists/' + checklist.id + '/search', {params: {search}})
  },

  showChecklistItem (checklist = {}, checklist_item = {}) {
    return HTTP.get('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id)
  },

  setCorrectiveDate (checklist = {}, checklist_item = {}) {
    return HTTP.post('set-corrective-date/' + checklist.id + '/chk-item/' + checklist_item.id, {corrective_date: checklist_item.corrective_date})
  },

  setCorrectiveStatus (checklist = {}, checklist_item = {}) {
    return HTTP.post('set-status/' + checklist.id + '/chk-item/' + checklist_item.id, {status: checklist_item.corrective_status})
  },

  getChecklistItemOfChecklist (checklist = {}) {
    return HTTP.get('get-checklist-item/' + checklist.id)
  }
}



// WEBPACK FOOTER //
// ./src/service/audit.js